import { ReactNode } from "react";

import { SiX } from "@icons-pack/react-simple-icons";

import Blum from "shared/assets/blum-logo.svg?react";
import FaceId from "shared/assets/svg/face-id.svg?react";

export type ZkCertType = "gip1" | "gip2" | "gip3";

type Cert = {
  title: string;
  icon: ReactNode;
  value: ZkCertType;
};

export const zkCertTypes: Cert[] = [
  {
    title: "zkKYC",
    icon: <FaceId className="size-6" />,
    value: "gip1" as ZkCertType,
  },
  {
    title: "Twitter / X.com",
    icon: <SiX className="size-6" />,
    value: "gip3" as ZkCertType,
  },
  {
    title: "Blum.io",
    icon: <Blum className="size-6" />,
    value: "gip2" as ZkCertType,
  },
];
